import Layout from "@/page/index/";

export default [{
        path: "/wel",
        component: Layout,
        redirect: "/wel/index",
        children: [{
                path: "index",
                name: "首页",
                meta: {
                    i18n: "dashboard",
                },
                component: () =>
                    import ( /* webpackChunkName: "views" */ "@/views/workbench/home"),
            },
            {
                path: "dashboard",
                name: "控制台",
                meta: {
                    i18n: "dashboard",
                    menu: false,
                },
                component: () =>
                    import ( /* webpackChunkName: "views" */ "@/views/wel/dashboard"),
            },
        ],
    },
    {
        path: "/test",
        component: Layout,
        redirect: "/test/index",
        children: [{
            path: "index",
            name: "测试页",
            meta: {
                i18n: "test",
            },
            component: () =>
                import ( /* webpackChunkName: "views" */ "@/views/util/test"),
        }, ],
    },
    {
        path: "/dict-horizontal",
        component: Layout,
        redirect: "/dict-horizontal/index",
        children: [{
            path: "index",
            name: "字典管理",
            meta: {
                i18n: "dict",
            },
            component: () =>
                import (
                    /* webpackChunkName: "views" */
                    "@/views/util/demo/dict-horizontal"
                ),
        }, ],
    },
    {
        path: "/dict-vertical",
        component: Layout,
        redirect: "/dict-vertical/index",
        children: [{
            path: "index",
            name: "字典管理",
            meta: {
                i18n: "dict",
            },
            component: () =>
                import (
                    /* webpackChunkName: "views" */
                    "@/views/util/demo/dict-vertical"
                ),
        }, ],
    },
    {
        path: "/info",
        component: Layout,
        redirect: "/info/index",
        children: [{
            path: "index",
            name: "个人信息",
            meta: {
                i18n: "info",
            },
            component: () =>
                import ( /* webpackChunkName: "views" */ "@/views/system/userinfo"),
        }, ],
    },
    {
      path: "/loan",
      component: Layout,
      redirect: "/loan/loanMessage",
      children: [{
          path: "loanMessage",
          name: "消息记录表",
          meta: {
              i18n: "info",
          },
          component: () =>
              import ( "@/views/loan/loanMessage"),
      }, ],
  },
  {
      path: "/workbench",
      component: Layout,
      redirect: "/workbench/myAudit",
      children: [{
          path: "myAudit",
          name: "我的签批",
          meta: {
              i18n: "info",
          },
          component: () =>
              import ( "@/views/workbench/myAudit.vue"),
      }, ],
  },
    {
        path: "/work/process/leave",
        component: Layout,
        redirect: "/work/process/leave/form",
        children: [{
                path: "form/:processDefinitionId",
                name: "请假流程",
                meta: {
                    i18n: "work",
                },
                component: () =>
                    import (
                        /* webpackChunkName: "views" */
                        "@/views/work/process/leave/form"
                    ),
            },
            {
                path: "handle/:taskId/:processInstanceId/:businessId",
                name: "处理请假流程",
                meta: {
                    i18n: "work",
                },
                component: () =>
                    import (
                        /* webpackChunkName: "views" */
                        "@/views/work/process/leave/handle"
                    ),
            },
            {
                path: "detail/:processInstanceId/:businessId",
                name: "请假流程详情",
                meta: {
                    i18n: "work",
                },
                component: () =>
                    import (
                        /* webpackChunkName: "views" */
                        "@/views/work/process/leave/detail"
                    ),
            },
        ],
    },
    {
        path: "/loanInformation",
        component: Layout,
        redirect: "/loanInformation/add",
        children: [{
            path: "add",
            name: "录入客户",
            component: () =>
                import ("@/views/loan/loanInformationAdd"),
            meta: {
                keepAlive: false,
                isTab: true,
                isAuth: true,
            },
        }, {
          path: "clientAdd",
          name: "录入客户",
          component: () =>
              import ("@/views/loan/loanInformationClientAdd"),
          meta: {
              keepAlive: false,
              isTab: true,
              isAuth: true,
          },
      },],
    },
];
